import type { Business, Weekday } from './validation.ts';
import { addDays, dateKeyInTz, minutesInTz, parseHours, weekdayOf, type DateKey } from './time.ts';

export const WEEK: readonly Weekday[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

/** Opening hours of a calendar day: null when closed (weekday off or closed date). */
export function hoursOn(business: Business, date: DateKey): [number, number] | null {
  if (business.closed_dates.includes(date)) return null;
  return parseHours(business.business_hours[weekdayOf(date)]);
}

export type OpenStatus =
  | { open: true; closesAt: number }
  | { open: false; next: { date: DateKey; opensAt: number; inDays: number } | null };

/** "Open now until 18:00" / "Closed, opens Monday 09:00" in the shop's timezone. */
export function openStatus(business: Business, now: Date): OpenStatus {
  const tz = business.timezone;
  const today = dateKeyInTz(now, tz);
  const minutes = minutesInTz(now, tz);
  const todayHours = hoursOn(business, today);
  if (todayHours && minutes >= todayHours[0] && minutes < todayHours[1]) return { open: true, closesAt: todayHours[1] };
  for (let i = 0; i <= 14; i++) {
    const date = addDays(today, i);
    const h = hoursOn(business, date);
    if (h && (i > 0 || minutes < h[0])) return { open: false, next: { date, opensAt: h[0], inDays: i } };
  }
  return { open: false, next: null };
}

export const hhmm = (minutes: number) => `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
